import { Injectable } from '@angular/core';
import { HttpClient,  } from '@angular/common/http';
import { Observable,  } from 'rxjs';
import { catchError, map,  } from 'rxjs/operators';
import { ErrorService } from 'src/app/service/error.service';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs';
import { GlobalComponent } from 'src/app/global/global.component';
@Injectable({
  providedIn: 'root'
})
export class DashboardHoursService extends Subject<DataStateChangeEventArgs>{
  constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent) {
    super();
  }

  getOIGAnalysis(): Observable<any> {
    let url = "api/Employee/GetLEIEMatchedEmployees"
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map((response: any) => response['Leie']),
      catchError(this.errorService.handleError)
    )
  }
  getmatchedLeie(state) {
    let url = "api/Employee/GetSuspeciousEmployees";
    return this.http.post<any>(url, state).pipe(
      map((response: any) =>
        <any>{
          result: response['result'],
          count: response['count']
        }),
      catchError(this.errorService.handleError)
    );
  }
  public executeExceeded(Exc): void {
    this.getExceededHoursList(Exc).subscribe(x => super.next(x));
  }
  getExceededHoursList(Exc): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/Timesheet/GetDashboardHoursDetailsExceeded", Exc)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['data'],
            count: response['totalCount']
          }
      ))
  }
  public outputValuesUnder(U): void {
    this.getUnderHoursList(U).subscribe(x => super.next(x));
  }
  getUnderHoursList(U): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/Timesheet/GetDashboardHoursDetailsUnder", U)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['data'],
            count: response['totalCount']
          }
      ))
  }
}
